import { render, staticRenderFns } from "./AddPropertyView.vue?vue&type=template&id=2da447b4&scoped=true"
import script from "./AddPropertyView.vue?vue&type=script&lang=js"
export * from "./AddPropertyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da447b4",
  null
  
)

export default component.exports